import ImpactHeader from "../components/header/ImpactHeader";
import SideBar from "../components/sidebar/Sidebar";
import Dashboard from "../components/Dashboard/Dashboard";
import ApplicationDetails from "../components/Application_details/ApplicationDetail";


export default function ApplicationDetailsLayout ({ props }) {

    return (
        <div>
            <SideBar />
            <ImpactHeader />
            <div className="impact-main-app-content">
                <ApplicationDetails/>
            </div>
        </div>

    )

}